<template>
  <div class="mult-input-intro">
    <div class="text" v-if="showList.text.length > 0 && !$slots.title">
      {{ showList.text[0].content }}
    </div>
    <div class="text" v-if="$slots.title">
      <slot name="title"></slot>
    </div>

    <template v-if="showOther > 0 && showList.other.length > 0">
      <div class="wrap">
        <template v-for="(other, index) in showList.other">
          <template v-if="index < showOther">
            <div class="box-out" :key="index">
              <!-- <div
                v-if="other.type === 'image'"
                class="box bg-cover"
                :style="`background-image: url('${other.url}');`"
              ></div> -->
              <div v-if="other.type === 'image'" class="box bg-cover">
                <el-image class="el-image" :src="other.url" :zoom-rate="1.2"
                  :preview-src-list="showList.other.filter(it => it.type === 'image').map(it => it.url)"
                  :initial-index="index" fit="cover" />
              </div>

              <!-- 视频缩略展示 -->
              <div v-else-if="other.type == 'video'" class="box bg-cover video"
                :style="`background-image: url('${getVideoThumbUrl(other)}');`" @click="playVideo(other)">
                <div class="to-play-icon"></div>
              </div>

              <!-- 精彩瞬间展示 西瓜视频 -->
              <template v-else-if="other.type === 'moment'">
                <!-- status: 1合成中，2合成成功，3合成失败 -->
                <!-- 已经有视频的url地址 -->
                <div v-if="other.url || other.status == 2" class="box bg-cover video"
                  :style="`background-image: url('${getVideoThumbUrl(other)}');`" @click="playVideo(other)">
                  <div class="to-play-icon"></div>
                </div>
                <!-- 一键生成视频or合成中视频：暂无视频的url地址 -->
                <div class="box bg-cover video-default" v-else-if="other.status == 1">
                  <!-- <van-loading color="var(--c1)" size="18" /> -->
                  <div v-loading="true" class="input-intro-loading" style="width: 46px; height: 46px;"></div>
                </div>
                <!-- 一键生成视频or合成中视频：合成失败 -->
                <div class="box bg-cover video-default" v-else-if="other.status == 3">
                  <div>
                    <img class="error-img" src="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/tips/empty.png" />
                    <!-- <p class="error-tips">视频合成失败</p> -->
                  </div>
                </div>
              </template>

              <div class="is-more" v-if="index == showOther - 1 && showList.other.length > showOther">更多</div>
            </div>
          </template>
        </template>
      </div>
    </template>

    <template v-if="showAudio && showList.audio.length > 0">
      <MultimediaRecord v-for="(audio, index) in showList.audio" :key="index" :record="audio"
        :style="{ 'margin-top': showOther > 0 && showList.other.length > 0 && index === 0 ? '0px' : '10px' }" />
    </template>
    <!-- 视频播放 -->
    <el-dialog v-model="dialogVideoVisible" :destroy-on-close="true" :append-to-body="true" width="840px"
      @close="videoSrc = ''">
      <video :src="videoSrc" controls="controls" height="600" width="800" style="margin: 0 auto; display: block;"
        autoplay>
        <track kind="captions" />
      </video>
    </el-dialog>
  </div>
</template>
<script>
import { computed, ref } from 'vue';
import MultimediaRecord from './child/multimedia-record.vue';

export default {
  name: 'mult-input-intro',
  props: {
    // 接一传入数据
    list: {
      type: Array,
      default: () => ([]),
    },
    // 是否展示多媒体信息
    showOther: {
      type: Number,
      default: 10,
    },
    showAudio: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    MultimediaRecord,
  },
  setup(props) {
    const dialogVideoVisible = ref(false);
    const videoSrc = ref('');
    const showList = computed(() => {
      const obj = {
        text: [],
        audio: [],
        other: [],
      };
      props.list.forEach((item) => {
        if (['aitext', 'text'].includes(item.type) && item.content) {
          obj.text.push(item);
        } else if (item.type === 'audio') {
          obj.audio.push(item);
        } else {
          obj.other.push(item);
        }
      });
      return obj;
    });
    return {
      dialogVideoVisible,
      videoSrc,
      showList,
      getVideoThumbUrl(item) {
        return item.thumburl || `${item.url}?x-oss-process=video/snapshot,t_1,f_jpg,w_1000`;
      },
      playVideo(v) {
        videoSrc.value = v.url;
        dialogVideoVisible.value = true;
      },
    };
  },
};
</script>
<style lang="scss" scoped>
// 多行文本省略号...
@mixin ellipsis-multi($num: 2) {
  display: -webkit-box;
  overflow: hidden;

  text-overflow: ellipsis;
  word-break: break-all;

  -webkit-box-orient: vertical;
  -webkit-line-clamp: $num;
}

.mult-input-intro {
  .text {
    font-size: 14px;
    line-height: 1.5;
    color: #303133;
    @include ellipsis-multi();
  }

  .wrap {
    display: flex;

    .box-out {
      position: relative;
      margin: 10px 10px 10px 0;
      width: 58px;
      height: 58px;
      border-radius: 4px;
      overflow: hidden;
      .el-image {
        width: 100%;
        height: 100%;
        border: 1px solid #EBEEF5;
      }
    }

    .box {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background-size: contain;
      cursor: pointer;

      &.video-default {
        background-color: #f5f5f5;
        // .warn {
        //   color: var(--c3);
        // }
      }

      .to-play-icon {
        width: 22px;
        height: 22px;
      }
    }

    .is-more {
      position: absolute;
      z-index: 2;
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
      background: rgba(0, 0, 0, .4);
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      cursor: pointer;
    }

    .error-img {
      width: 46px;
      height: 46px;
      object-fit: contain;
    }

    .error-tips {
      font-size: 12px;
    }
  }
}
</style>
<style lang="scss">
.input-intro-loading {
  .el-loading-mask {
    background-color: transparent !important;
  }
}
</style>
